<div class="error-page">
    <h2>Error:</h2>
    <p>{{ errorMessage }}</p>
  </div>